import { render, staticRenderFns } from "./PaymentStatus.vue?vue&type=template&id=4846fc4a"
import script from "./PaymentStatus.vue?vue&type=script&lang=js"
export * from "./PaymentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports